import { render, staticRenderFns } from "./AdvertisingTable.vue?vue&type=template&id=b1cb60fc"
import script from "./AdvertisingTable.vue?vue&type=script&lang=js"
export * from "./AdvertisingTable.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingTable.vue?vue&type=style&index=0&id=b1cb60fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports